<template>
    <div class="engine engine__ms-luis">
        <div class="label">
          {{ $t('common.modals.create_external.engines.ms-luis.engine.label') }}
        </div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.ms-luis.engine.description') }}
          <a class="engine--info-url" :href="msLuisUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.ms-luis.here') }}
          </a>
        </div>

        <or-select
            v-model="$props.luisModel.settings.method"
            :label="$t('common.modals.create_external.engines.ms-luis.engine.method.label')"
            :options="['POST', 'GET']"
        />

        <or-textbox
            v-model="$props.luisModel.settings.url"
            :label="$t('common.modals.create_external.engines.ms-luis.enterUrl.label')"
            :placeholder="$t('common.modals.create_external.engines.ms-luis.enterUrl.placeholder')"
        />

        <or-textbox
            v-model="$props.luisModel.settings.subscriptionKey"
            :label="$t('common.modals.create_external.engines.ms-luis.subscriptionKey.label')"
            :placeholder="$t('common.modals.create_external.engines.ms-luis.subscriptionKey.placeholder')"
        />

        <or-code
            v-model="$props.luisModel.settings.bodyTemplate"
            :label="$t('common.modals.create_external.engines.ms-luis.bodyTemplate.label')"
            mode="json"
            :full-screen="false"
            :invalid="!!settingsErrors.bodyTemplate"
            :error="settingsErrors.bodyTemplate"
        />

        <div class="settings-wrap">
            <p>{{ $t('common.modals.create_external.engines.ms-luis.queryParams.label') }}</p>

            <or-switch
                :value="localQueryParamsTemplate.log"
                @input="updateLogging"
            >
              {{ $t('common.modals.create_external.engines.ms-luis.log') }}
            </or-switch>

            <or-switch
                :value="localQueryParamsTemplate['show-all-intents']"
                @input="updateShowAllIntents"
            >
              {{ $t('common.modals.create_external.engines.ms-luis.showAllIntents') }}
            </or-switch>

            <or-textbox
                v-model.number="localQueryParamsTemplate.timezoneOffset"
                @input="updateTimezoneOffset"
                :label="$t('common.modals.create_external.engines.ms-luis.timezoneoffset')"
                type="number"
            />
        </div>
    </div>
</template>

<script>
import { isValidJSON } from '@/utils/validations'
import { MS_LUIS_DOCS_URL } from '@/config'

export const getDefaultLuisSettings = () => ({
  method: 'POST',
  url: '',
  subscriptionKey: '',

  queryParamsTemplate: JSON.stringify({
    verbose: true, // not allow user to change
    log: false,
    'show-all-intents': true,
    timezoneOffset: 0
  }),
  bodyTemplate: JSON.stringify({})
})

export default {
  props: {
    luisModel: {
      settings: {
        url: String,
        method: String,
        subscriptionKey: String,
        queryParamsTemplate: String,
        bodyTemplate: String
      }
    },
    errors: {
      settings: {
        bodyTemplate: String
      }
    }
  },

  data () {
    return {
      msLuisUrl: MS_LUIS_DOCS_URL
    }
  },

  methods: {
    updateLogging (logValue) {
      this.localQueryParamsTemplate = {
        ...this.localQueryParamsTemplate,
        log: logValue
      }
    },

    updateShowAllIntents (showIntents) {
      this.localQueryParamsTemplate = {
        ...this.localQueryParamsTemplate,
        'show-all-intents': showIntents
      }
    },

    updateTimezoneOffset (newOffset) {
      this.localQueryParamsTemplate = {
        ...this.localQueryParamsTemplate,
        timezoneOffset: parseInt(newOffset, 10) || 0
      }
    }
  },

  computed: {
    localQueryParamsTemplate: {
      get () {
        if (isValidJSON(this.luisModel.settings.queryParamsTemplate)) {
          return JSON.parse(this.luisModel.settings.queryParamsTemplate)
        }
        return getDefaultLuisSettings().queryParamsTemplate
      },
      set (newValue) {
        this.$emit('update:luisModel', {
          ...this.luisModel,
          settings: {
            ...this.luisModel.settings,
            queryParamsTemplate: JSON.stringify(newValue)
          }
        })
      }
    },

    settingsErrors () {
      return this.$props.errors.settings || {}
    }
  }
}
</script>

<style lang="scss" scoped>
    .engine__ms-luis {
    }
</style>
